import { createSlice } from '@reduxjs/toolkit';
import { clearStoredToken } from '../../user-storage';

const slice = createSlice({
  name: 'user',
  initialState: {
    userName: null,
    darkMode: false,
    currentLang: 'en',
    token: null,
    companyName: null,
    practitioner: null,
  },
  reducers: {
    setUserName: (user, action) => {
      user.userName = action.payload;
    },
    setToken: (user, action) => {
      user.token = action.payload;
    },
    setPractitioner: (user, action) => {
      user.practitioner = action.payload;
    },
    setCompanyName: (user, action) => {
      user.companyName = action.payload;
    },
    setDarkMode: (user, action) => {
      user.darkMode = action.payload;
    },
    setCurrentLang: (user, action) => {
      user.currentLang = action.payload;
    },
    setDataUser: (user, action) => {
      user.data = action.payload;
    },
    clearUser: (user) => {
      user.data = null;
      user.token = null;
      user.darkMode = false;
      user.currentLang = 'en';
      user.companyName = null;
      user.practitioner = null;
      user.userName = null;

      clearStoredToken();
    },
  },
});

export const {
  setUserName,
  setPractitioner,
  setDarkMode,
  setCurrentLang,
  clearUser,
  setToken,
  setCompanyName,
  setDataUser,
} = slice.actions;

export default slice.reducer;
